import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20anime%20inspired%20soft%20pastel%20pink%20gradient%20abstract%20background%2C%20sakura%20petals%20floating%20gently%2C%20dreamy%20ethereal%20atmosphere%2C%20soft%20bokeh%20lights%2C%20magical%20sparkle%20effects%2C%20warm%20peach%20and%20cream%20tones%2C%20whimsical%20fairytale%20vibe%2C%20clean%20elegant%20composition&width=1600&height=900&seq=hero-bg-loli&orientation=landscape"
          alt="Loli文化二次元萌系美学"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          {t('home.hero.title')}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
          {t('home.hero.subtitle')}
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <a
            href="/category/loli-culture"
            className="px-7 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('home.hero.cta')}
          </a>
          <a
            href="/about"
            className="px-7 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('home.hero.secondary')}
          </a>
        </div>
      </div>
    </section>
  );
}